export const DOCUMENT_TYPES = [
  'Articles of Organization',
  'Operating Agreement',
  'EIN Confirmation',
  'Annual Report',
  'Tax Filing',
  'Compliance Document',
  'Other',
];
